<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<router-link data-toggle="tooltip" title="Отказ" class="btn btn-default" to="/moderate/category/list"><i class="fa fa-times"></i></router-link>
					<button type="button" data-toggle="tooltip" title="Запис" class="btn btn-success" @click="onSubmit()"><i class="fa fa-save"></i></button>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content-->
	<div class="container-fluid" v-if="dataReady">

		<div class="card">
			<div class="card-block">

				<f-input
					v-model="category.name" name="category_name"
					v-validate="'required'" :errors="errorBag.collect('category_name')"
					:cplaceholder="'(пример: Четене)'">
				</f-input>

				<f-select
					v-model="category.scope" name="category_scope"
					v-validate="'required'" :errors="errorBag.collect('category_scope')" :values="$config.lists.categoryScopes">
				</f-select>

				<f-category
					v-model="category.parent" name="category_parent"
					v-validate="''" :errors="errorBag.collect('category_parent')"
					:csingle="true">
				</f-category>

			</div> <!-- end card-block -->
		</div> <!-- end card -->
	</div>
</div>
</template>

<script>
var cache = require('../base/category/category-cache');
module.exports = {
	data: function () {
		return {
			category: {},
			dataReady: false
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function () {
			if (!this.$route.params.id) {
				this.dataReady = true;
				this.category = {
					name: '',
					scope: undefined,
					parent: ''
				};
				return;
			}

			this.$http.get('backend://category/' + this.$route.params.id).then((response) => {
				this.category = response.body;
				if (this.category.parent !== undefined) {
					this.category.parent = this.category.parent + '';
				}
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		onSubmit: function () {
			if (this.category.parent === '') {
				this.category.parent = undefined;
			}
			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				this.$http.putOrPostResource('backend://category/', this.category).then((response) => {
					cache.update(this);
					this.$router.push('/moderate/category/list');
				}).catch(this.$http.toastCatcher);
			});
		}
	}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// CategoryEdit.vue?423b191e